import { FONT_SIZE, FONT_WEIGHT, Heading as _Heading, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const SecRootHighlight = styled.section`
  margin-bottom: 32px;
`;

export const Heading = styled(_Heading)`
  font-size: ${FONT_SIZE.M}px;
  font-weight: ${FONT_WEIGHT.BOLD};
  margin-bottom: 8px;
`;

export const DivHTMLWrapper = styled.div`
  // テキストは折り返す and 改行コードで改行可能にする
  white-space: pre-wrap;
  font-size: ${FONT_SIZE.M}px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.S}px;
  }
`;
